import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import {List, ListItem, ListItemText, ListItemIcon} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

const MenuListItem = ({label, url, iconComponent: IconComponent}) => (
    <ListItem
        className="menu-item quizscape-menu-list-item"
        component={ React.forwardRef((props, ref) => <NavLink {...props} />)}
        to={url}
        button={false}
    >
        <ListItemIcon
            className="quizscape-item-icon quizscape-menu-list-item"
        >
            {IconComponent()}
        </ListItemIcon>
        <ListItemText className="quizscape-item-text quizscape-menu-list-item" primary={label}/>
    </ListItem>
);

MenuListItem.propTypes = {
    label: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    iconComponent: PropTypes.func.isRequired,
};

const DrawerMenu = () => (
    <List component="nav">
        <div className="menu-items">
            {/*<MenuListItem*/}
            {/*    className="quizscape-menu-list-item"*/}
            {/*    label="Dashboard"*/}
            {/*    url="/dashboard"*/}
            {/*    iconComponent={DashboardIcon}*/}
            {/*/>*/}
            <MenuListItem
                className="quizscape-menu-list-item"
                label="Quizzes"
                url="/quizzes"
                iconComponent={QuizIcon}
            />
            <MenuListItem
                className="quizscape-menu-list-item"
                label="Questions"
                url="/questions"
                iconComponent={QuizBankIcon}
            />
            <MenuListItem
                className="quizscape-menu-list-item"
                label="Users"
                url="/users"
                iconComponent={UsersIcon}
            />
            <MenuListItem
                className="quizscape-menu-list-item"
                label="Settings"
                url="/settings"
                iconComponent={SettingsIcon}
            />
        </div>
    </List>
);

const QuizIcon = () => (
    <IconButton>
        <img className="quiz-icon" />
    </IconButton>
);

const QuizBankIcon = () => (
    <IconButton>
        <img className="quiz-bank-icon" />
    </IconButton>
);

const SettingsIcon = () => (
    <IconButton>
        <img className="settings-icon" />
    </IconButton>
);

const UsersIcon = () => (
    <IconButton>
        <img className="users-icon" />
    </IconButton>
);


DrawerMenu.contextTypes = {
    router: PropTypes.object.isRequired,
};

DrawerMenu.propTypes = {
};

export default DrawerMenu;
